<template>
    <div class="grey lighten-3" >
      <v-container>
        <v-row>
          <v-col cols="2" md="3" class="d-none d-lg-block d-md-block">
            <div style="position: sticky; top: 0;  padding-top: 10px  ">
              <v-sheet rounded="lg"  >
              <v-list color="transparent">
                 <v-list-item
                  link
                  @click="goto('divtop')"
                  color="grey lighten-4"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      Menú de navegación
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              </v-sheet>

              <br/>

              <v-sheet rounded="lg"  >
              <v-list color="transparent">
                
                <v-subheader> <span><B>Búsqueda simple</B></span></v-subheader>

                 <v-list-item
                  link
                  @click="goto('div1')"
                  color="grey lighten-4"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      Realizar búsqueda
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  link
                  @click="goto('div2')"
                  color="grey lighten-4"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      Vizualizar el historial
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              </v-sheet>

              <br/>

              <v-sheet rounded="lg">
                <v-list color="transparent">

                  <v-subheader> <span><B>Búsqueda múltiple</B></span></v-subheader>

                  <v-list-item
                    link
                    @click="goto('div3')"
                    color="grey lighten-4"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        Realizar búsqueda
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item
                    link
                    @click="goto('div4')"
                    color="grey lighten-4"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        Vizualizar el historial
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-sheet>
            </div>

          </v-col>

          <v-col md="9" style="padding-top: 20px" >
            <v-sheet
              min-height="70vh"
              rounded="lg"
            >
              <div class="div" ref="divtop">
                <span>
                <h3>Menú de navegación</h3>
                <HR/>
                <BR/>
                En este menú se encuentra:
                <ol>
                  <li style="margin: 0">El botón de acceso a las ayudas de la aplicación</li>
                  <li style="margin: 0">El botón de cerrar sesión</li>
                  <li style="margin: 0">El botón para regresar a la página principal</li>
                  <img class="image-fit" src="./../assets/images/nav1.png" style="max-width: 80%; max-height:100px"/>
                </ol>
                </span>
              </div>
              <div class="div" ref="div1">
                <span>
                <h3>Búsqueda simple</h3>
                <HR/>
                <BR/>
                  <h4>¿Cómo realizar una búsqueda de dirección simple?</h4>
                  Para realizar una búsqueda de dirección simple debe realizar los siguientes pasos:
                  <ol>
                    <img class="image-fit" src="./../assets/images/bs1.png"/>
                    <li>Situese en la pestaña Simple<br/>Nota: Sólo podrá ingresar una dirección a la vez.</li>
                    <li>Coloque la ubicación que desea consultar en el campo Dirección.</li>
                    <img class="image-fit" src="./../assets/images/bs2.png" height="200px"/>
                    <li>A continuación, se muestra un pin en el mapa indicando la ubicación ingresada.</li>
                    <img class="image-fit" src="./../assets/images/bs3.png" height="200px"/>
                    <li>La coloración azul sobre el mapa, representa la cobertura de la red sigfox. Si el pin de ubicación se encuentra fuera de la coloración azul, significa que está fuera de la cobertura.</li>
                    <img class="image-fit" src="./../assets/images/bs4.png" height="200px"/>
                    <li>Podrá ampliar o reducir la vista del mapa utilizando los botones ubicados en la parte inferior derecha del mapa. </li>
                    <img class="image-fit" src="./../assets/images/bs5.png" height="200px"/>
                    <li>Para ver el mapa en pantalla completa, haga clic en el botón ubicado en la parte superior derecha del mapa</li>
                    <img class="image-fit" src="./../assets/images/bs6.png" height="200px"/>
                    <li>Haga clic nuevamente para volver a la vista anterior</li>
                    <img class="image-fit" src="./../assets/images/bs7.png" height="200px"/>
                  </ol>
                </span>
              </div>
              <div class="div" ref="div2">
                <span>
                  <h4>¿Cómo visualizar el historial de búsquedas simples?</h4>
                  <ol>
                    <li>En la parte inferior se mostrará el historial de búsquedas recientes.</li>
                    <img class="image-fit" src="./../assets/images/bs8.png" height="200px"/>
                    <li>Al seleccionar una ubicación, se podrá visualizar su posición en el mapa.</li>
                    <img class="image-fit" src="./../assets/images/bs9.png" height="200px"/>
                  </ol>
                </span>
              </div>
              <div class="div" ref="div3">
                <span>
                <h3>Búsqueda Múltiple</h3>
                <HR/>
                <BR/>
                  <h4>¿Cómo realizar una búsqueda de dirección múltiple?</h4>
                  Para realizar una búsqueda de dirección múltiple debe realizar los siguientes pasos:

                  <ol>
                    <li>Sitúese en la pestaña Múltiple.</li>
                    <img class="image-fit" src="./../assets/images/bm1.png" />
                    <li>En el campo de “Búsqueda por Json” se podrá escribir directamente las direcciones en el formato establecido o simplemente arrastrar un archivo Json. 
                      <br/>
                      La estructura para ingresar las direcciones es la siguiente: 
                      <ul style="list-style-type:none;">
                        <li style="margin: 0"><b>{Objeto}</b>: Se colocan las llaves que representan el objeto.</li>
                        <li style="margin: 0"><b>"places"</b>: Se colocará este campo dentro del objeto. </li>
                        <li style="margin: 0"><b>[Array]</b>: Luego, se colocará entre corchetes el arreglo de cadenas de caracteres pertenecientes al campo dentro del objeto. </li>
                      </ul>
                      <br/>
                      Ejemplo:

      <div class="grey lighten-3" style="margin-right: 40px; margin-top:20px; margin-bottom:20px">      
      <pre>
      {
        "places" : [
        "Albino Garcia 149, Centro, 38000 Celaya, Gto., México ", 
        "Av. Cuauhtémoc 1973-2065, Cristóbal Colón, 91755 Veracruz, Ver., México", 
        "Ciudad de Mexico, Mexico"
        ]
      }</pre>
      </div>
                    NOTA: Cada dirección se debe colocar entre comillas y se deben ir separadas por una coma. 
                    <img class="image-fit" src="./../assets/images/bm2.png" height="200px"/>
                    </li>
                    <li>A continuación, se muestra los pines en el mapa indicando todas las ubicaciones ingresadas. </li>
                    <img class="image-fit" src="./../assets/images/bm3.png" height="200px"/>
                    <li>La coloración azul sobre el mapa, representa la cobertura de la red sigfox. Si el pin de ubicación se encuentra fuera de la coloración azul, significa que está fuera de la cobertura.</li>
                    <img class="image-fit" src="./../assets/images/bm4.png" height="200px"/>
                    <li>Podrá ampliar o reducir la vista del mapa utilizando los botones ubicados en la parte inferior derecha del mapa.</li>
                    <img class="image-fit" src="./../assets/images/bm5.png" height="200px"/>
                    <li>Para ver el mapa en pantalla completa, haga clic en el botón ubicado en la parte superior derecha del mapa.</li>
                    <img class="image-fit" src="./../assets/images/bm6.png" height="200px"/>
                    <li>Haga clic nuevamente para volver a la vista anterior.</li>
                    <img class="image-fit" src="./../assets/images/bm7.png" height="200px"/>
                  </ol>
                </span>
              </div>

               <div class="div" ref="div4">
                <span>
                  <h4>¿Cómo visualizar el historial de búsquedas múltiples?</h4>
                  <ol>
                    <li>En la parte inferior se mostrará el historial de búsquedas recientes.</li>
                    <img class="image-fit" src="./../assets/images/bm8.png" height="100px"/>
                    <li>Al seleccionar una ubicación, se podrá visualizar su posición en el mapa.</li>
                    <img class="image-fit" src="./../assets/images/bm9.png" height="200px"/>
                  </ol>
                </span>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </div>

</template>

<script>
  export default {
    data: () => ({
      links: [
        'Búsqueda simple',
        'Realizar búsqueda de dirección',
        'Visualizar el historial',
        'Updates',
      ],
    }),
      methods: {
    goto(refName) {
      var element = this.$refs[refName];
      element.scrollIntoView();
    }
  }
  }
</script>

<style scoped>
  .div{
    padding: 20px;
  }

  .div li{
    margin-bottom: 20px;
  }

  .div h4{
    margin: 20px;
    text-align: center;
  }

  pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
  }

  .image-fit {
    display:block;
    margin:auto;
    margin-top: 15px;
    margin-bottom: 15px;
}
</style>